import AuthForm from "../AuthForm";

export default function Login() {
  return <AuthForm mode="login" />;
}
